import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a63f23e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searched-patient-card" }
const _hoisted_2 = { class: "searched-patient-card__content" }
const _hoisted_3 = { class: "searched-patient-card__name" }
const _hoisted_4 = { class: "searched-patient-card__info" }

import { computed, PropType } from 'vue'
import { PatientType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  patient: Object as PropType<PatientType>,
},
  setup(__props) {

const props = __props



const date = computed(() => props.patient.date)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.patient.surname) + " " + _toDisplayString(__props.patient.name) + " " + _toDisplayString(__props.patient.patronymic ?? ''), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(date)) + ", Мед. карта №" + _toDisplayString(__props.patient.cart_number), 1)
    ]),
    _renderSlot(_ctx.$slots, "remove")
  ]))
}
}

})